export default "__VITE_ASSET__b9592e1a__"